import React from 'react';
import { Pagination } from 'antd';

const PaginationComponent = ({ current, pageSize, totalItems, onPageChange }) => {
  const handlePageChange = (page, size) => {
    onPageChange(page, size); // Pass back to parent
  };

  return (
    <Pagination
      current={current}
      pageSize={pageSize}
      total={totalItems}
      onChange={handlePageChange}
      showSizeChanger
    />
  );
};

export default PaginationComponent;